import { Edit } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import { useNavigate } from 'react-router-dom'

export function ColumnActions(props) {
    const navigate = useNavigate()

    const openRemoveDialog = () => {
        props.setRowToModify(props.row)
        props.setOpen(true)
    }

    const editObj = (row) => {
        navigate("/_fazenda?uid=" + row.uid);
    }

    return (
        <div style={{ display: "flex", justifyContent: "start", height: "100%" }}>
            <IconButton size="small" onClick={() => editObj(props.row)}>
                <Edit />
            </IconButton>
            <IconButton onClick={openRemoveDialog}>
                <DeleteIcon />
            </IconButton>
        </div>
    )
}